import { render, staticRenderFns } from "./CategoryOffer.vue?vue&type=template&id=58a6631a&"
import script from "./CategoryOffer.vue?vue&type=script&lang=js&"
export * from "./CategoryOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports